module.exports = __webpack_public_path__ + "static/media/Template_9.fec30491.png";